import leaveTypeService from "../../v2/services/leaveTypeService";

export const getDynamicLeaveConfig = async () => {
  const res = await leaveTypeService.getActive();
  const activeLeaves = res.data || [];

  const fields = [];
  activeLeaves.forEach((leave) => {
    fields.push({
      key: `total_${leave.id}`,
      label: `Total ${leave.description}`,
      type: "decimal",
      width: 30,
      sampleValue: "<10.00>",
      leaveTypeId: leave.id, // metadata for mapping
      isTotal: true
    });
    fields.push({
      key: `remaining_${leave.id}`,
      label: `${leave.description} Remaining`,
      type: "decimal",
      width: 30,
      sampleValue: "<10.00>",
      leaveTypeId: leave.id, // metadata for mapping
      isRemaining: true
    });
  });

  return { apiKey: "employeeLeaveBalances", fields };
};